import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { ProductsServices } from "../../../services";
import { StaticsServices } from '../../../../services/statics';
import { TranslateService } from '@ngx-translate/core';
import { ArticlesListPage } from '../../../../articles/articles-list/articles-list';
import { ProductCreateWfoodcostImagePage } from '../product-create-wfoodcost-image/product-create-wfoodcost-image';
import { AnalyticsServices } from '../../../../services/analyticsServices';
import * as firebase from 'firebase';
import * as fuzzball from 'fuzzball';
import { AIServices } from '../../../../services/aiServices';
import { AddonsTriggerVersionProPage } from '../../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the ProductCreateWfoodcostAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-create-wfoodcost-allergens',
    templateUrl: 'product-create-wfoodcost-allergens.html',
})
export class ProductCreateWfoodcostAllergensPage {

    product_uid: string;
    update_state: boolean = false;
    product_name: string;
    product_measurement: any;
    product: any;

    show_alert: boolean = true;

    // IA
    AlergansListAi: any = Array();
    article_type: any;
    article_uid: any;
    LoaderGifIA: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public productsServices: ProductsServices,
        public staticsServices: StaticsServices,
        public translate: TranslateService,
        private alertCtrl: AlertController,
        private analyticsServices: AnalyticsServices,
        public aiServices: AIServices) {

        this.product_uid = this.navParams.get('product_uid');
        this.update_state = this.navParams.get('update_state');
        this.product_name = this.navParams.get('product_name');
        this.product_measurement = this.navParams.get('product_measurement');
        this.product = this.navParams.get('product');

        this.article_type = this.navParams.get('article_type');
        this.article_uid = this.navParams.get('article_uid');


        if (!this.update_state) {
            //Vaciamos el tmporal de allergens para que si es un plato nuevo siempre este vacio.
            this.productsServices.products_allergens_tmp = [];
        } else {
            if (this.navParams.get('allergens') != undefined) {
                this.productsServices.products_allergens_tmp = this.navParams.get('allergens');
            }
        }

    }


    //obtener todos los allergenos
    async getAllergens() {
        let array_allergans = []
        let Firebase = firebase.firestore()
        let allergans = await Firebase.collection('allergens').get()

        allergans.forEach(doc => {
            array_allergans.push({
                id: doc.id,
                allergan: doc.data().es
            }
            );
        })
        return array_allergans
    }

    //recuperamos los datos del articulo
    async getProduct() {
        let product
        if (this.article_type === 'product' && !this.update_state) {
            product = await this.productsServices.getProduct(this.article_uid) //recuperamos el nombre

        }
        else { product = this.product; }
        if (product && !Array.isArray(product.allergens)) {
            this.productsServices.afs.collection('products').doc(this.product_uid).update({
                'allergens': [],
            });
            product.allergens = []
            this.productsServices.products_allergens_tmp = []
        }
        return product
    }

    //Recuperamos el nombre descripcion
    getNameDescriptionFoodcost(product, type) {

        let name
        let descripcion
        let foodcost


        if (type == 'dish') {
            name = this.globals.nameLangSelectDish(product)
            descripcion = this.globals.descriptionLangSelectArticle(product);
            foodcost = Array.isArray(product.foodcost) && product.foodcost.length > 0 ? product.foodcost.map(item => item.name_static).join(", ") : "";
            return { name, descripcion, foodcost }
        }
        else {
            name = this.globals.nameLangSelectProduct(product)
            descripcion = this.globals.descriptionLangSelectArticle(product)
            foodcost = ""
            return { name, descripcion, foodcost }
        }
    }


    //hacemos la funcion de IA para obtener los allergenos
    async AiAllergens() {
        if (this.globals.checkLimitsByLicense('dishes', 'ai')) {
            try {
                this.LoaderGifIA = true;
                var List_allergans = await this.getAllergens();
                var Product = await this.getProduct();
                let { name, descripcion, foodcost } = this.getNameDescriptionFoodcost(Product, this.article_type);
                // miramos si hay escandallo 
                var HasFoodCost = "";
                if (this.article_type === 'dish') {
                    HasFoodCost = `Nombre y descripción del plato/producto, incluido el escandallo:  Nombre: ${name}, Descripción: ${descripcion},  escandallo: ${foodcost}`
                }
                else {
                    HasFoodCost = `Nombre y descripción del plato/producto:  Nombre: ${name}  ,  Descripcion: ${descripcion}`
                }
                //prepare params for ai services
                var timeout = 30000;
                var response_format = { type: "json_object" };
                var messages = [
                    {
                        role: "system",
                        content: "inicia processo de busqueda de alérgenos y indicadores para platos y productos y devuelve resultados en json"
                    },
                    {
                        role: "user",
                        content: 'Voy a proporcionarte un JSON con la lista de alérgenos conocidos y posibles indicadores asociados a platos y productos.'
                    },
                    {
                        role: "assistant",
                        content: "Entendido. Por favor, comparte el JSON de alérgenos e indicadores que necesitaré para la búsqueda."
                    },
                    {
                        role: "user",
                        content: JSON.stringify(List_allergans)
                    },

                    {
                        role: "assistant",
                        content: "Recibido. ¿Cuál es el nombre del plato o producto para el que debo buscar alérgenos e indicadores?"
                    },
                    {
                        role: "user",
                        content: HasFoodCost
                    },
                    {
                        role: "assistant",
                        content: "Entendido. Al buscar alérgenos e indicadores para este plato/producto, ¿hay alguna consideración específica que deba tener en cuenta?"
                    },
                    {
                        role: "user",
                        content: `ASí, por favor:

                        Realiza una búsqueda detallada de alérgenos basándote en los ingredientes mencionados, prestando especial atención a los tipos de carne especificados.
                        La búsqueda de indicadores debe ser precisa, aplicando solo a los componentes exactos del plato.
                        Limita la búsqueda de alérgenos a los tipos de carne mencionados en el nombre y descripción del plato. Evita buscar otros tipos de carne no mencionados.
                        No incluyas alérgenos o indicadores que no estén en la lista proporcionada.`
                    },
                    {
                        role: "assistant",
                        content: "¿Cómo prefieres que te presente los resultados de la búsqueda?"
                    },
                    {
                        role: "user",
                        content: `Por favor, entrega los resultados en formato JSON mezclando alérgenos con indicadores. Utiliza el formato: { alergenos_indicadores: [{'nombre': '[Nombre del alérgeno o indicador]'}] }. Mantén la precisión sin añadir información no encontrada.`

                    },
                    {
                        role: "assistant",
                        "content": "Si no identifico alérgenos o indicadores directamente en la información proporcionada, ¿cómo debo proceder?"
                    },
                    {
                        role: "user",
                        content: "Utiliza un enfoque creativo para inferir posibles alérgenos o indicadores basándote en los ingredientes y datos disponibles. Sin embargo, mantén la precisión y evita añadir elementos no verificados."
                    }
                ];
                //call ai service function
                const response = await this.aiServices.openAIGenerateText(response_format, messages, timeout);
                this.LoaderGifIA = false;
                // convertimos el json text a json
                var AiResponse = response['choices'][0].message.content;
                var json_Response = JSON.parse(AiResponse);
                // ckekeamos los resultados que se ha obtenido bien
                await this.CheckResultWithName(List_allergans, json_Response);
                //editamos el array para mostrarlos al usuario
                await this.editAllerganWithAI();
            } catch {
                let alert = await this.alertCtrl.create({
                    title: this.translate.instant('articulos-alert-timeout-title'),
                    message: this.translate.instant('articulos-alert-timeout-text'),
                    buttons: [
                        {
                            text: this.translate.instant('general-aceptar'),
                            role: 'cancel',
                            handler: () => {
                            }
                        },
                    ]
                });
                alert.present()
                this.LoaderGifIA = false;
            }
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }


    async CheckResultWithName(getAlllergans, ResultAI) {

        //chekeamos los allerganos y obtenemos los uid de los alerganos
        let OptionsFuzz = {
            scorer: fuzzball.ratio,// Any function that takes two values and returns a score, default: ratio
            processor: choice => choice.allergan,  // Takes choice object, returns string, default: no processor. Must supply if choices are not already strings.
            limit: 1, // Max number of top results to return, default: no limit / 0.
            cutoff: 85, // Lowest score to return, default: 0
            unsorted: false // Results won't be sorted if true, default: false. If true limit will be ignored.
        };

        //recoreemos los resultados de IA para obtener los nombres y id
        for (let i = 0; i < ResultAI.alergenos_indicadores.length; i++) {

            var results = await fuzzball.extract(ResultAI.alergenos_indicadores[i].nombre, getAlllergans, OptionsFuzz);
            var choiceObjects = results.map(result => result[0]);
            this.AlergansListAi.push(choiceObjects)
        }
    }

    // mostramos al usuarios los allergenos y evitamos repiticiones 
    editAllerganWithAI() {
        let NewAllergens = []
        let message = ""
        let subtitle = ""
        let getNamesAllergensAndIndicadors = ""


        // buscamos si hay resultados
        if (this.AlergansListAi) {
            this.AlergansListAi.forEach((item) => {
                if (item[0]) {
                    let index = this.productsServices.products_allergens_tmp.findIndex(allergen => allergen === item[0].id);
                    if (index === -1) {
                        this.productsServices.products_allergens_tmp.push(item[0].id);
                        NewAllergens.push(item[0].id)
                    }
                }
            });
        }

        if (NewAllergens.length > 0) {
            for (let i = 0; i < NewAllergens.length; i++) {
                let name = this.globals.getAllergenName(NewAllergens[i])

                if (i === NewAllergens.length - 1) {
                    getNamesAllergensAndIndicadors += `${name}. `
                }
                else {
                    getNamesAllergensAndIndicadors += `${name}, `
                }
            }

            subtitle = `${this.translate.instant('general_hemos_encontrado_alergeno_indicador')}`
            message = getNamesAllergensAndIndicadors

            let alert = this.alertCtrl.create({
                title: this.translate.instant('general-alergenos-indicadores'),
                message: message,
                subTitle: subtitle,
                buttons: [
                    {
                        text: this.translate.instant('general-aceptar'),
                        role: 'cancel',
                    },
                ],
            });
            alert.present();
        }
        else {
            let alert = this.alertCtrl.create({
                title: this.translate.instant('general-atencion'),
                message: this.translate.instant('general_no_hemos_encontrado_alergeno_indicador'),
                buttons: [
                    {
                        text: this.translate.instant('general-aceptar'),
                        role: 'cancel',
                    },
                ],
            });
            alert.present();
        }
    }

    ionViewCanLeave(): Promise<void> {
        return new Promise((resolve, reject) => {
            //Si el show_alert es true i no estem fen un update al plat
            if (this.show_alert && !this.update_state) {
                let alert = this.alertCtrl.create({
                    title: this.translate.instant('general-atencion'),
                    message: this.translate.instant('general-salir-proceso-creacion'),
                    subTitle: this.translate.instant('general-se-eliminara-elemento'),
                    buttons: [
                        {
                            text: this.translate.instant('general-no'),
                            role: 'cancel',
                            handler: () => {
                                this.globals.side_menu_active = 'stock';
                                reject();
                            },
                        },
                        {
                            text: this.translate.instant('general-si'),
                            handler: () => {
                                this.productsServices.afs.collection('products').doc(this.product_uid).delete();
                                resolve();
                                this.navCtrl.setRoot(ArticlesListPage);
                            },
                        },
                    ],
                });
                alert.present();
            } else {
                resolve();
            }
        });
    }

    update() {
        this.show_alert = false;
        this.productsServices.afs.collection('products').doc(this.product_uid).update({
            'allergens': this.productsServices.products_allergens_tmp,
            'updated_at': new Date(),
            'updated_user': this.globals.user_name
        }).then(() => {
            //dataset plat_alergen
            for (let allergen_id of this.productsServices.products_allergens_tmp) {
                this.globals.dataSet('product_alergen', this.globals.getAllergenName(allergen_id), '', this.product_name);
            }
            //redirect
            this.analyticsServices.trackingExpArticles('update product', this.globals.tracking_exp['update_article'], this.product_uid);
            if (this.update_state) {
                this.globals.GAtrackView('Products', 'Products - Allergens - Update', this.globals.restaurant.email, 'Create/Update', 'Update allergens', 'Products', this.product_name);
                this.staticsServices.changeStateStaticWait(true);
                this.navCtrl.pop();
            } else {
                this.globals.GAtrackView('Products', 'Products - Allergens - Create', this.globals.restaurant.email, 'Create/Update', 'Create allergens', 'Products', this.product_name);
                this.navCtrl.push(ProductCreateWfoodcostImagePage, {
                    update_state: this.update_state,
                    product_uid: this.product_uid,
                    product_name: this.product_name,
                    product: this.product
                });
            }

        });
    }
    ionViewWillEnter() {
        if (!this.globals.checkLimitsByLicense('stock', 'indicators')) { //miramos la licencia del restaurante
            this.changeClass();
        }
    }

    changeClass() {
        const indicators = document.getElementsByClassName('indicators');
        for (let i = 0; i < indicators.length; i++) {
            const slide = indicators[i] as HTMLElement;
            slide.style.filter = "grayscale(1)";
            slide.style.opacity = "30%";
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-allergens/product-create-wfoodcost-allergens.ts